import React from 'react';
import styled from 'styled-components';
import Modal from 'components/modal';

const EmbedWrapper = styled.div`
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const EmbedViewer = ({ open, url, onClose }) => {
  if (!open || !url) return null;

  return (
    <Modal open={open} onClose={onClose} width="90vw" height="90vh" radius={8} closeVariant="solid">
      <EmbedWrapper>
        <iframe src={url} allowFullScreen title="Media viewer" />
      </EmbedWrapper>
    </Modal>
  );
};

export default EmbedViewer;
